import { render } from "./PortfolioDetailsPage.vue?vue&type=template&id=1bf8ad73&ts=true"
import script from "./PortfolioDetailsPage.vue?vue&type=script&lang=ts"
export * from "./PortfolioDetailsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__